import { Component, Input } from '@angular/core';
import { OeAppPersonService } from '../../../../../shared/oe-app-person.service';
import { SCSS_COLORS } from '../../../../../../colors';
import { FutureClassTile } from '../../../../live-class-section/class-tile/future-class-tile';
import { LiveClassTile } from '../../../../live-class-section/class-tile/live-class-tile';

@Component({
  selector: 'lp2-group-class-tile-states',
  templateUrl: './group-class-tile-states.component.html',
  styleUrls: ['./group-class-tile-states.component.scss'],
})
export class GroupClassTileStatesComponent {
  @Input() liveClassTile: LiveClassTile | FutureClassTile;

  public colors = SCSS_COLORS;

  constructor(private oeAppPersonService: OeAppPersonService) {}

  onClick() {
    if (!this.oeAppPersonService.showOnboardingModalOnGroupClass()) {
      this.liveClassTile.onTileClick();
    }
  }

  onShowDocumentClick(event: PointerEvent) {
    if (!this.oeAppPersonService.showOnboardingModalOnGroupClass()) {
      this.liveClassTile.onShowDocumentClick(event);
    }
  }

  onCancel(event: Event) {
    if (this.liveClassTile instanceof LiveClassTile) {
      this.liveClassTile.onCancel(event);
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile-states/group-class-tile-states.component.ts